import useI18n from "@/hooks/useI18n";
import { css } from "@styled-system/css";
import { Box } from "@styled-system/jsx";

type Props = { className?: string };

export function GiftCardPageHeading({ className }: Props) {
  const { t } = useI18n();
  return (
    <Box className={className}>
      <h2 className={css({ mb: "1rem", textAlign: "center", px: "0.5rem" })}>{t("giftCard.giftMain.title")}</h2>
      <p
        className={css({
          px: "0.5rem",
          textAlign: "center",
          textStyle: "subheader"
        })}
      >
        {t("giftCard.giftMain.subtitle")}
      </p>
    </Box>
  );
}
